import { minihelpRecommend } from '../services/getMiniHelpRecommendArticle';

const sptlightMapping = {
  en_US: 'help',
  es_XC: 'Ayuda',
  zh_XC: '說明',
  fr_XC: 'Aide',
};

const communityChannel = 'COMMUNITY';

function filterFaqID(element) {
  if (element.type === 'FAQ') {
    return true;
  }
  return false;
}

function filterContactChannel(element) {
  if (element.type === 'email' || element.type === 'callus' || element.type === 'community' || element.type === 'seller' || element.type === 'chat') {
    return true;
  }
  return false;
}

function filterWebformDetail(element) {
  return !filterFaqID(element) && !filterContactChannel(element);
}

function articleDataParser(body) {
  const formElements = body.web_form_template;
  const faqid = formElements.form_elements.filter(filterFaqID);
  const contactChannel = formElements.form_elements.filter(filterContactChannel);
  const webformDetail = formElements.form_elements.filter(filterWebformDetail);

  const formObj = formElements;
  formObj.form_elements = {};
  formObj.topicRefId = body.ref_id;
  formObj.form_elements.faqid = (faqid.length > 0) ? faqid : undefined;
  formObj.form_elements.contact_channel = (contactChannel.length > 0) ? contactChannel : undefined;
  formObj.form_elements.webform_detail = (webformDetail.length > 0) ? webformDetail : undefined;

  return { formInfo: formObj };
}

function parseAutoComplete(response) {
  const parsedResponse = [];
  if (Array.isArray(response)) {
    response.forEach((article) => {
      parsedResponse.push({
        title: article.articleTitle,
        docid: article.articleId,
      });
    });
  }
  return parsedResponse;
}

/**
 * return AutoComplete result which is array of object
 * [{
 *  segment,
 *  suggestions: [{docid, title, action}, ...]
 * }, ... ]
 * @return Array
 */
function parseMiniAutoComplete(response, locale) {
  const parsedResponse = [];
  const keysSet = Object.keys(response);
  if (Array.isArray(keysSet) && keysSet.length > 0) {
    keysSet.forEach((key) => {
      const suggestionLists = response[key];
      if (Array.isArray(suggestionLists) && suggestionLists.length > 0 && !key.includes(sptlightMapping[locale])) {
        const suggestions = suggestionLists.map(suggestion => ({
          docid: suggestion.id,
          title: suggestion.keyword,
          action: suggestion.action,
        }));
        parsedResponse.push({
          segment: key,
          suggestions,
        });
      }
    });
  }
  return parsedResponse;
}

function communitySearchParser(response) {
  const parsedResponse = [];
  if (Array.isArray(response)) {
    response.forEach((message) => {
      parsedResponse.push({
        articleTitle: message.subject.$,
        link: message.view_href,
        views: message.views.count.$,
        articleId: message.id.$,
        channel: communityChannel,
      });
    });
  }
  return parsedResponse;
}

function miniHelpSearchParser(response, q, locale) {
  const constResult = parseMiniAutoComplete(minihelpRecommend(q, locale), locale);
  const helpResult = parseAutoComplete(response);
  if (Array.isArray(helpResult) && helpResult.length > 0) {
    return [...constResult, {
      segment: sptlightMapping[locale],
      suggestions: helpResult,
    }];
  }
  return constResult;
}

function isNotEmptySuggestion(suggestions) {
  return Array.isArray(suggestions) && suggestions.some(suggest => suggest && Array.isArray(suggest.suggestions) && suggest.suggestions.length > 0);
}

function parseKmSearchResults(response) {
  if (Array.isArray(response.results)) {
    return response.results.map((result, index) => ({
      title: result.title,
      docid: result.docid,
      rank: index + 1, // TODO:: For now i am assigning the index to rank. Replace this with API rank/priority once the service is ready.
    }));
  }
  return [];
}

function miniHelpKmSearchSpotLightParser(response, q, locale) {
  const constResult = parseMiniAutoComplete(minihelpRecommend(q, locale), locale);
  const helpResult = parseKmSearchResults(response);
  if (Array.isArray(helpResult) && helpResult.length > 0) {
    return [...constResult, {
      segment: sptlightMapping[locale],
      suggestions: helpResult,
    }];
  }
  return constResult;
}

module.exports = {
  articleDataParser,
  parseAutoComplete,
  communitySearchParser,
  miniHelpSearchParser,
  isNotEmptySuggestion,
  parseKmSearchResults,
  miniHelpKmSearchSpotLightParser,
};
